import { Data } from 'common';

const { Countries } = Data;

export default (userData = {}) => {
	const {
		ContactId = null,
		FullName = '',
		FirstName = '',
		MiddleName = '',
		LastName = '',
		Prefix = '',
		Suffix = '',
		Company = '',
		Department = '',
		Title = '',
		Email = '',
		Phone = '',
		PhoneExt = '',
		Street1 = '',
		Street2 = '',
		Street3 = '',
		City = '',
		State = '',
		Zip = '',
		ZipAddOn = '',
		PostalCode = '',
		CountryId = 203,
		CountryCode = 'US',
		Province = '',
		CostCode = '<None>',
		CostCodeId = -1,
		ReferenceNumber = '',
		CreationTime = '',
		LastUpdateTime = '',
		IsPOBox = false,
		CleanseHash = '',
	} = userData;

	const fullName =
		FullName ||
		`${Prefix} ${FirstName}${MiddleName && ` ${MiddleName}`}${`${
			LastName && ` ${LastName}`
		}${`${Suffix && ` ${Suffix}`}`}`}`.trim();

	const country = Countries.filter(
		countrys => countrys.countryCode === CountryCode
	);

	return {
		ContactId,
		FullName: fullName,
		FirstName,
		MiddleName,
		LastName,
		Prefix,
		Suffix,
		Company,
		Department,
		Title,
		Email,
		Phone,
		PhoneExt,
		Street1,
		Street2,
		Street3,
		City,
		State,
		Zip,
		ZipAddOn,
		PostalCode,
		CountryId,
		CountryCode,
		Province,
		CostCode: CostCode === '<None>' || CostCode === 'None' ? '' : CostCode,
		CostCodeId,
		ReferenceNumber,
		CreationTime,
		LastUpdateTime,
		IsPOBox,
		AddressSummary: `${fullName}, -${City}, ${State || Province}`,
		CleanseHash,
		CleanseStatus: '',
		Country: CountryCode,
		CountryName: country.countryName,
		DisplayName: fullName,
		DisplayStr: `${fullName}, -${City}, ${State || Province}`,
		FullAddress: `${FullName},
		${Street1},
		${City}, ${State || Province} ${Zip}`,
		IsPOBoxAddress: IsPOBox,
		OriginZip: Zip,
		PhoneNumber: Phone,
		RecordId: '',
		ResidentialDeliveryIndicator: '',
		StateProvince: `${State || Province}`,
		StreetAddress: Street1,
		ZIPCode: Zip,
		ZIPCodeAddOn: ZipAddOn,
		ZIPPlus4: `${Zip}-${ZipAddOn}`,
		freeFormAddress: '',
		isCompanyContact: '',
		isCustomsRequired: '',
		notInStore: '',
		ToolTip: `<b>Mail From ZIP:</b><br><br><br><b>Return To Address:</b><br>${fullName},<br>${Street1},<br>${City}, ${
			State || Province
		} ${Zip}`,
	};
};
